import { KeyedMutator } from 'swr';

import { IRichModalProps } from '@shared/components/modals/RichModal';
import { colorTheme, extraColor } from '@styles/muiTheme';

import { NContact } from '../../components/Contact/validation';
import { IDeal as IDealCalculator, IDealSummary } from '../../components/Deals/interfaces';
import { ILead } from '../../components/Leads/types/interfaces/interfaces';
import { IDeal } from './models/DealModel';
import { IEligibleLender } from './models/EligibleLenderModel';
import { IGlobalInputs } from './models/GlobalInputsModel';
import { IIneligibleLender } from './models/IneligibleLender';

export interface ILendersHeader {
  assetId: string;
  contactName: string;
  state: string;
  city: string;
  zip: string;
  modelYear?: number;
  make?: string;
  model: string;
  odomter?: string;
  vehicleAge?: number;
  vehicleType?: string;
  payOff: number;
  leadSource: string;
}
export interface ILendersResponse {
  globalInputs: IGlobalInputs;
  deal: IDeal;
  eligibleLenders: IEligibleLender[];
  ineligibleLender: IIneligibleLender[];
  header?: ILendersHeader;
}

export interface IUpdateProductRetail {
  productTypeName: string;
  newRetail: number;
  leadId: string;
  lenderCode: string;
  reason: string;
}
export interface ILenderFooterState {
  rate: number;
  payment: number;
  term: number;
  remainingTerm: number;
  GAP: number;
  VSC: number;
  PAF: number;
  downPayment: number;
  additionalNotes: string | null;
  paymentDate: string;
  currentDTI : number;
  newDTI : number;
}

export interface IGlobalInputsPostData {
  salesPrice: number;
  cashOut: number;
  downPayment: number;
  rateMarkup: number;
  term: number;
  additionalNotes: string;
  isAch?: boolean;
  coContactId?: string;
}

export interface ILenderInputPostData {
  lenderCode: string;
  cashOut: number;
  downPayment: number;
  rateMarkup: number;
  term: number;
  approvedRate: number;
  vscRetail: number;
  gapRetail: number;
  comRetail: number;
  pafRetail: number;
  vrpRetail: number;
  totalDebt: number;
  totalUnsecuredDebt: number;
  firstPaymentDays: number;
  contractDate: string;
  rateAdjustment: number;
  isAch: boolean;
}

export interface ISaveDealCaldData {
  globalInputs: IGlobalInputsPostData;
  lenderInputs: ILenderInputPostData[];
}

export enum CreditRuleCellType {
  Header = 'Header',
  GreyOut = 'GreyOut',
  Warning = 'Warning',
  Eligible = 'Eligible',
  NotEligible = 'NotEligible',
  CreditSummary = 'CreditSummary',
  Normal = 'Normal',
  Failed = 'Failed',
  Yellow = 'Yellow',
  FailedYellow = 'FailedYellow'
}

export const creditRuleColorCSS = {
  [CreditRuleCellType.Failed]: {
    backgroundColor: extraColor.palette.error.secondary,
  },
  [CreditRuleCellType.Yellow]: {
    backgroundColor: extraColor.palette.orange.main
  },
  [CreditRuleCellType.FailedYellow]: {
    backgroundColor: extraColor.palette.orange.main,
    color: colorTheme.palette.error.main
  },
  [CreditRuleCellType.CreditSummary]: {
    backgroundColor: colorTheme.palette.orange[200]
  },
  [CreditRuleCellType.Eligible]: {
    color: colorTheme.palette.success.main
  }
};

export interface IDealCalculatorRequest {
  dealId?: string;
  estimatedScore?: number | null;
  leadId?: string;
  contactId?: string;
  coContactId?: string;
  isDealEdit?: boolean;
  isEstimatedScore?: boolean;
}

export interface IDealCalculatorProps extends IRichModalProps {
  data: Partial<IDealCalculatorRequest>;
  refreshLeads?: KeyedMutator<ILead[]>;
  refreshDeals?: KeyedMutator<IDealSummary[]>;
  reloadDeal?: KeyedMutator<IDealCalculator>;
  contactAddress?: NContact.Address;
  handleClosePopUp?: () => void;
  assetNumericId?: number,
  numericId?: number,
  isVoidEnable?: boolean,
  reloadContactAlerts: () => void;
}

export enum DefaultValuationMethods {
  KbbRetail = 'Kbb',
  NadaRetail = 'Jd Power',
  Msrp = 'Msrp',
  KbbTradeIn = 'Trade In',
  KbbWholesale = 'Kbb Wholesale',
  KbbFinanceExpress = 'Kbb Finance Express',
  NadaTradeIn = 'Jd Power Trade In'
}
